export const isUnauthorizedRequestError = (error: any) =>
  error?.info?.code === 401 || error?.response?.status === 401;
